module.exports = __webpack_public_path__ + "static/media/calendar-error.1d4d17ff.svg";